import React from 'react';
import { Link } from 'react-router-dom';
import ChatButton from '../components/ChatButton';

const PrivacyPolicy = () => {
  return (
    <>
      <div className="content_page_wrapper">
        {/* Simple Banner Section */}
        <div style={{
          padding: '3rem 0',
          textAlign: 'center',
          marginTop: '100px'
        }}>
          <div className="container" style={{ maxWidth: '800px', margin: '0 auto', padding: '0 2rem' }}>
            <h1 style={{
              fontSize: '3rem',
              fontWeight: '700',
              color: '#4A7C59',
              marginBottom: '1rem',
              lineHeight: '1.2'
            }}>
              Privacy Policy
            </h1>
            <p style={{
              fontSize: '1.2rem',
              color: '#2D5A27',
              lineHeight: '1.6',
              margin: '0'
            }}>
              Your privacy and data security are our top priorities
            </p>
          </div>
        </div>

        {/* Content Section */}
        <div style={{
          background: 'linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)',
          padding: '4rem 0',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            position: 'absolute',
            top: '0',
            left: '0',
            right: '0',
            bottom: '0',
            background: 'radial-gradient(circle at 70% 30%, rgba(30, 64, 175, 0.05) 0%, transparent 50%)',
            pointerEvents: 'none'
          }}></div>
          
          <div className="container" style={{ maxWidth: '1000px', margin: '0 auto', padding: '0 2rem', position: 'relative', zIndex: '1' }}>
            <div style={{
              background: 'rgba(255, 255, 255, 0.95)',
              borderRadius: '20px',
              boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
              padding: '3rem',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              backdropFilter: 'blur(10px)',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <div style={{
                position: 'absolute',
                top: '0',
                left: '0',
                right: '0',
                height: '4px',
                background: 'linear-gradient(90deg, #1e40af, #3b82f6)',
                zIndex: '1'
              }}></div>
              
              <div style={{ marginBottom: '2rem' }}>
                <p style={{
                  fontSize: '1.1rem',
                  lineHeight: '1.7',
                  color: '#64748b',
                  marginBottom: '2rem'
                }}>
                  <strong style={{ color: '#1e293b' }}>Udhaar Portal</strong> ("we," "our," "us") operates the https://www.udhaarportal.com website (the "Service"). This Privacy Policy explains how we collect, use, and share your personal information when you use our Service.
                </p>
              </div>

              <div style={{ marginBottom: '2rem' }}>
                <h2 style={{
                  fontSize: '1.8rem',
                  fontWeight: '700',
                  color: '#1e293b',
                  marginBottom: '1rem',
                  borderLeft: '4px solid #1e40af',
                  paddingLeft: '1rem'
                }}>
                  Information We Collect
                </h2>
                <p style={{
                  fontSize: '1rem',
                  lineHeight: '1.6',
                  color: '#64748b',
                  marginBottom: '1rem'
                }}>
                  We collect information you provide directly to us, such as when you create an account, apply for a loan, or contact us for support. This may include:
                </p>
                <ul style={{
                  listStyle: 'none',
                  padding: '0',
                  margin: '1rem 0'
                }}>
                  <li style={{
                    padding: '0.5rem 0',
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: '1rem',
                    color: '#64748b'
                  }}>
                    <span style={{
                      width: '8px',
                      height: '8px',
                      background: '#1e40af',
                      borderRadius: '50%',
                      marginRight: '1rem',
                      flexShrink: '0'
                    }}></span>
                    Personal identification information (name, email address, phone number)
                  </li>
                  <li style={{
                    padding: '0.5rem 0',
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: '1rem',
                    color: '#64748b'
                  }}>
                    <span style={{
                      width: '8px',
                      height: '8px',
                      background: '#1e40af',
                      borderRadius: '50%',
                      marginRight: '1rem',
                      flexShrink: '0'
                    }}></span>
                    Financial information (income, employment details, bank statements)
                  </li>
                  <li style={{
                    padding: '0.5rem 0',
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: '1rem',
                    color: '#64748b'
                  }}>
                    <span style={{
                      width: '8px',
                      height: '8px',
                      background: '#1e40af',
                      borderRadius: '50%',
                      marginRight: '1rem',
                      flexShrink: '0'
                    }}></span>
                    Identity verification documents (PAN card, Aadhaar, address proof)
                  </li>
                </ul>
              </div>

              <div style={{ marginBottom: '2rem' }}>
                <h2 style={{
                  fontSize: '1.8rem',
                  fontWeight: '700',
                  color: '#1e293b',
                  marginBottom: '1rem',
                  borderLeft: '4px solid #1e40af',
                  paddingLeft: '1rem'
                }}>
                  How We Use Your Information
                </h2>
                <p style={{
                  fontSize: '1rem',
                  lineHeight: '1.6',
                  color: '#64748b',
                  marginBottom: '1rem'
                }}>
                  We use the information we collect to:
                </p>
                <ul style={{
                  listStyle: 'none',
                  padding: '0',
                  margin: '1rem 0'
                }}>
                  <li style={{
                    padding: '0.5rem 0',
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: '1rem',
                    color: '#64748b'
                  }}>
                    <span style={{
                      width: '8px',
                      height: '8px',
                      background: '#1e40af',
                      borderRadius: '50%',
                      marginRight: '1rem',
                      flexShrink: '0'
                    }}></span>
                    Process your loan applications and provide financial services
                  </li>
                  <li style={{
                    padding: '0.5rem 0',
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: '1rem',
                    color: '#64748b'
                  }}>
                    <span style={{
                      width: '8px',
                      height: '8px',
                      background: '#1e40af',
                      borderRadius: '50%',
                      marginRight: '1rem',
                      flexShrink: '0'
                    }}></span>
                    Verify your identity and prevent fraud
                  </li>
                  <li style={{
                    padding: '0.5rem 0',
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: '1rem',
                    color: '#64748b'
                  }}>
                    <span style={{
                      width: '8px',
                      height: '8px',
                      background: '#1e40af',
                      borderRadius: '50%',
                      marginRight: '1rem',
                      flexShrink: '0'
                    }}></span>
                    Communicate with you about our services
                  </li>
                  <li style={{
                    padding: '0.5rem 0',
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: '1rem',
                    color: '#64748b'
                  }}>
                    <span style={{
                      width: '8px',
                      height: '8px',
                      background: '#1e40af',
                      borderRadius: '50%',
                      marginRight: '1rem',
                      flexShrink: '0'
                    }}></span>
                    Comply with legal and regulatory requirements
                  </li>
                </ul>
              </div>

              <div style={{ marginBottom: '2rem' }}>
                <h2 style={{
                  fontSize: '1.8rem',
                  fontWeight: '700',
                  color: '#1e293b',
                  marginBottom: '1rem',
                  borderLeft: '4px solid #1e40af',
                  paddingLeft: '1rem'
                }}>
                  Information Sharing
                </h2>
                <p style={{
                  fontSize: '1rem',
                  lineHeight: '1.6',
                  color: '#64748b',
                  marginBottom: '1rem'
                }}>
                  We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except in the following circumstances:
                </p>
                <ul style={{
                  listStyle: 'none',
                  padding: '0',
                  margin: '1rem 0'
                }}>
                  <li style={{
                    padding: '0.5rem 0',
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: '1rem',
                    color: '#64748b'
                  }}>
                    <span style={{
                      width: '8px',
                      height: '8px',
                      background: '#1e40af',
                      borderRadius: '50%',
                      marginRight: '1rem',
                      flexShrink: '0'
                    }}></span>
                    With service providers who assist us in operating our business
                  </li>
                  <li style={{
                    padding: '0.5rem 0',
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: '1rem',
                    color: '#64748b'
                  }}>
                    <span style={{
                      width: '8px',
                      height: '8px',
                      background: '#1e40af',
                      borderRadius: '50%',
                      marginRight: '1rem',
                      flexShrink: '0'
                    }}></span>
                    To comply with legal obligations or protect our rights
                  </li>
                  <li style={{
                    padding: '0.5rem 0',
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: '1rem',
                    color: '#64748b'
                  }}>
                    <span style={{
                      width: '8px',
                      height: '8px',
                      background: '#1e40af',
                      borderRadius: '50%',
                      marginRight: '1rem',
                      flexShrink: '0'
                    }}></span>
                    In connection with a business transfer or merger
                  </li>
                </ul>
              </div>

              <div style={{ marginBottom: '2rem' }}>
                <h2 style={{
                  fontSize: '1.8rem',
                  fontWeight: '700',
                  color: '#1e293b',
                  marginBottom: '1rem',
                  borderLeft: '4px solid #1e40af',
                  paddingLeft: '1rem'
                }}>
                  Data Security
                </h2>
                <p style={{
                  fontSize: '1rem',
                  lineHeight: '1.6',
                  color: '#64748b',
                  marginBottom: '1rem'
                }}>
                  We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. Our security measures include:
                </p>
                <ul style={{
                  listStyle: 'none',
                  padding: '0',
                  margin: '1rem 0'
                }}>
                  <li style={{
                    padding: '0.5rem 0',
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: '1rem',
                    color: '#64748b'
                  }}>
                    <span style={{
                      width: '8px',
                      height: '8px',
                      background: '#1e40af',
                      borderRadius: '50%',
                      marginRight: '1rem',
                      flexShrink: '0'
                    }}></span>
                    Encryption of data in transit and at rest
                  </li>
                  <li style={{
                    padding: '0.5rem 0',
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: '1rem',
                    color: '#64748b'
                  }}>
                    <span style={{
                      width: '8px',
                      height: '8px',
                      background: '#1e40af',
                      borderRadius: '50%',
                      marginRight: '1rem',
                      flexShrink: '0'
                    }}></span>
                    Regular security assessments and updates
                  </li>
                  <li style={{
                    padding: '0.5rem 0',
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: '1rem',
                    color: '#64748b'
                  }}>
                    <span style={{
                      width: '8px',
                      height: '8px',
                      background: '#1e40af',
                      borderRadius: '50%',
                      marginRight: '1rem',
                      flexShrink: '0'
                    }}></span>
                    Access controls and authentication measures
                  </li>
                </ul>
              </div>

              <div style={{ marginBottom: '2rem' }}>
                <h2 style={{
                  fontSize: '1.8rem',
                  fontWeight: '700',
                  color: '#1e293b',
                  marginBottom: '1rem',
                  borderLeft: '4px solid #1e40af',
                  paddingLeft: '1rem'
                }}>
                  Your Rights
                </h2>
                <p style={{
                  fontSize: '1rem',
                  lineHeight: '1.6',
                  color: '#64748b',
                  marginBottom: '1rem'
                }}>
                  You have the right to:
                </p>
                <ul style={{
                  listStyle: 'none',
                  padding: '0',
                  margin: '1rem 0'
                }}>
                  <li style={{
                    padding: '0.5rem 0',
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: '1rem',
                    color: '#64748b'
                  }}>
                    <span style={{
                      width: '8px',
                      height: '8px',
                      background: '#1e40af',
                      borderRadius: '50%',
                      marginRight: '1rem',
                      flexShrink: '0'
                    }}></span>
                    Access and review your personal information
                  </li>
                  <li style={{
                    padding: '0.5rem 0',
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: '1rem',
                    color: '#64748b'
                  }}>
                    <span style={{
                      width: '8px',
                      height: '8px',
                      background: '#1e40af',
                      borderRadius: '50%',
                      marginRight: '1rem',
                      flexShrink: '0'
                    }}></span>
                    Request correction of inaccurate information
                  </li>
                  <li style={{
                    padding: '0.5rem 0',
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: '1rem',
                    color: '#64748b'
                  }}>
                    <span style={{
                      width: '8px',
                      height: '8px',
                      background: '#1e40af',
                      borderRadius: '50%',
                      marginRight: '1rem',
                      flexShrink: '0'
                    }}></span>
                    Request deletion of your personal information
                  </li>
                  <li style={{
                    padding: '0.5rem 0',
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: '1rem',
                    color: '#64748b'
                  }}>
                    <span style={{
                      width: '8px',
                      height: '8px',
                      background: '#1e40af',
                      borderRadius: '50%',
                      marginRight: '1rem',
                      flexShrink: '0'
                    }}></span>
                    Withdraw consent for data processing
                  </li>
                </ul>
              </div>

              <div style={{ marginBottom: '2rem' }}>
                <h2 style={{
                  fontSize: '1.8rem',
                  fontWeight: '700',
                  color: '#1e293b',
                  marginBottom: '1rem',
                  borderLeft: '4px solid #1e40af',
                  paddingLeft: '1rem'
                }}>
                  Contact Us
                </h2>
                <p style={{
                  fontSize: '1rem',
                  lineHeight: '1.6',
                  color: '#64748b',
                  marginBottom: '1rem'
                }}>
                  If you have any questions about this Privacy Policy or our data practices, please contact us at:
                </p>
                <div style={{
                  background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
                  padding: '1.5rem',
                  borderRadius: '15px',
                  color: 'white',
                  marginTop: '1rem',
                  boxShadow: '0 8px 32px rgba(30, 64, 175, 0.3)'
                }}>
                  <p style={{ margin: '0', fontSize: '1rem' }}>
                    <strong>Email:</strong> care@UdhaarPortal.com
                  </p>
                  <p style={{ margin: '0.5rem 0 0 0', fontSize: '1rem' }}>
                    <strong>Address:</strong> Udhaar Portal Financial Services, India
                  </p>
                </div>
              </div>

              <div style={{ marginBottom: '2rem' }}>
                <h2 style={{
                  fontSize: '1.8rem',
                  fontWeight: '700',
                  color: '#1e293b',
                  marginBottom: '1rem',
                  borderLeft: '4px solid #1e40af',
                  paddingLeft: '1rem'
                }}>
                  Changes to This Privacy Policy
                </h2>
                <p style={{
                  fontSize: '1rem',
                  lineHeight: '1.6',
                  color: '#64748b',
                  marginBottom: '1rem'
                }}>
                  We may update this Privacy Policy from time to time. We will notify you of any significant changes by posting the new Privacy Policy on our website.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ChatButton />
    </>
  );
};

export default PrivacyPolicy;
